import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import { fetchData } from '../../../apiService';
import { FaLock } from "react-icons/fa";
import phonepe from '../Img/phonepe.png';

const Payment = () => {
    const { id, planid } = useParams();
    const history = useHistory();
    const [plan, setPlan] = useState(null);

    const fetchtableData = async () => {
        try {
            const response = await fetchData('SubscriptionPlansApi', `/selectedplan/${planid}`);
            if (response.responseCode === '1111') {
                setPlan(response.response_data);
            }
        } catch (error) {
            console.error('Error fetching Subscription Plans Details:', error);
        }
    };

    useEffect(() => {
        fetchtableData();
    }, []);

    const handlePayment = (method) => {
        alert(`Payment via ${method} successful for ${plan.Name} plan!`);
        history.push("/");
    };

    if (!plan) return null;

    return (
        <div style={{
            padding: "40px",
            maxWidth: "600px",
            margin: "50px auto",
            background: "#fff",
            borderRadius: "12px",
            boxShadow: "0 0 20px rgba(0,0,0,0.1)",
            fontFamily: "Arial, sans-serif",
            backgroundColor: "#1a1a1a",
        }}>
            {/* Lock Icon & Step */}
            <div style={{ textAlign: "center", marginBottom: "20px" }}>
                <h6 style={{ color: "whitesmoke", textTransform: 'uppercase', fontWeight: 'bold' }}>Payment Details</h6>
            </div>

            {/* Plan Details */}
            <div style={{
                backgroundColor: "#2E2E2E",
                borderRadius: "8px",
                marginBottom: "20px",
                textAlign: "left",
                color: "whitesmoke",
            }}>
                <h6 style={{ marginBottom: "10px", fontFamily: 'monospace', marginLeft: '20px' }}>{plan.Name} Plan</h6>
                <p><strong style={{ marginTop: '-5px', fontSize: '14px', fontFamily: 'monospace', marginLeft: '20px' }}>Duration:</strong> {plan.PlanDuration} days</p>
                <p style={{ marginTop: '-5px', fontFamily: 'monospace' }}><strong style={{ fontSize: '14px', fontFamily: 'monospace', marginLeft: '20px' }}>Description:</strong> {plan.Description}</p>
                <p style={{ marginTop: '-5px', fontSize: "18px", color: "#9ee4d2ff", fontFamily: 'monospace' }}>
                    <strong style={{ marginTop: '-5px', fontFamily: 'monospace', marginLeft: '20px' }}>Amount: ₹{plan.Amount}</strong>
                </p>
            </div>

            {/* Payment Option 1 */}
            <div style={{ marginBottom: "15px", border: "1px solid #ddd", borderRadius: "8px", cursor: "pointer", backgroundColor: "#2E2E2E", color: "#fff" }}
                onClick={() => handlePayment("Credit/Debit Card")}>
                <div style={{ padding: "15px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <span style={{ fontFamily: 'monospace', fontWeight: 'bold', color: 'whitesmoke' }}>Credit or Debit Card</span>
                    <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                        <img src="https://img.icons8.com/color/32/visa.png" alt="visa" />
                        <img src="https://img.icons8.com/color/32/mastercard.png" alt="mastercard" />
                    </div>
                </div>
            </div>

            {/* Payment Option 2 */}
            <div style={{ border: "1px solid #ddd", borderRadius: "8px", cursor: "pointer", backgroundColor: "#2E2E2E", color: "#fff" }}
                onClick={() => handlePayment("UPI AutoPay")}>
                <div style={{ padding: "15px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <span style={{ fontFamily: 'monospace', fontWeight: 'bold', color: 'whitesmoke' }}>UPI AutoPay</span>
                    <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                        <img src={phonepe} style={{ width: "29px", height: "29px", borderRadius: '25px' }} />
                        <img src="https://img.icons8.com/color/32/google-pay.png" alt="gpay" />
                        <img style={{ background: 'white', borderRadius: '10px',width:'30%' }} src="https://img.icons8.com/color/32/paytm.png" alt="paytm" />
                    </div>
                </div>
            </div>


            <div style={{ marginTop: "30px", textAlign: "center" }}>
                <p style={{ color: "#888", fontSize: "12px" }}>End-to-end encrypted 🔒</p>
            </div>
        </div>
    );
};

export default Payment;
